import React from 'react';
import styled from 'styled-components';
import mascot from '../../assets/mascot.svg';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import MonochromePhotosIcon from '@mui/icons-material/MonochromePhotos';
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext';

import { useNavigate } from 'react-router-dom';

function Sidebar() {
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      console.log('You are logged out');
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <SidebarStyled className="sidebar">
      <div className="top">
        <Link to="/admin/dashboard" className="logo-link">
          <img src={mascot} alt="" />
          <span className="logo">Imafeel</span>
        </Link>
      </div>

      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/admin/dashboard">
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <p className="title">LISTS</p>
          <Link to="/admin/users">
            <li>
              <PeopleOutlineOutlinedIcon className="icon" />
              <span>Users</span>
            </li>
          </Link>
          <Link to="/admin/photos">
            <li>
              <MonochromePhotosIcon className="icon" />
              <span>Photos</span>
            </li>
          </Link>
          <Link to="/admin/albums">
            <li>
              <PhotoAlbumIcon className="icon" />
              <span>Albums</span>
            </li>
          </Link>

          <p className="title">USEFUL</p>
          <Link to="/admin/stats">
            <li>
              <BarChartIcon className="icon" />
              <span>Stats</span>
            </li>
          </Link>

          <p className="title">ADMIN</p>
          <Link to="/admin/profile">
            <li>
              <AccountCircleIcon className="icon" />
              <span>Profile</span>
            </li>
          </Link>
          <li onClick={handleLogout}>
            <div className="logout">
              <LogoutIcon className="icon" />
              <span>Logout</span>
            </div>
          </li>
        </ul>
      </div>
    </SidebarStyled>
  );
}

const SidebarStyled = styled.div`
  flex: 1;
  border-right: 0.5px solid rgb(231, 228, 228);

  background-color: #fff;
  color: var(--accent-blue);

  .top {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 0.5px solid rgb(231, 228, 228);
    @media screen and (max-width: 600px) {
      height: 56px;
    }

    .logo-link {
      display: flex;
      align-items: center;

      .logo {
        font-size: 20px;
        font-weight: bold;
        color: var(--accent-blue);
        padding: 10px;
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .center {
    padding-left: 10px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      .title {
        font-size: 10px;
        font-weight: bold;
        color: #999;
        margin-top: 15px;
        margin-bottom: 5px;
      }
      li {
        display: flex;
        align-items: center;
        padding: 5px;
        cursor: pointer;
        &:hover {
          background-color: #ece8ff;
        }
        .icon {
          font-size: 18px;
          color: var(--accent-blue);
        }
        span {
          font-size: 13px;
          font-weight: 600;
          color: #888;
          margin-left: 10px;
        }
        .logout {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
      }
    }
  }
`;

export default Sidebar;
